<template>
  <div class="login-page">
    <div class="bg-circle bg-circle-a" />
    <div class="bg-circle bg-circle-b" />
    <div class="bg-circle bg-circle-c" />
    <div class="glass-cube cube-a" />
    <div class="glass-cube cube-b" />
    <div class="glass-cube cube-c" />
    <div class="login-shell">
      <div class="login-header">
        <h1>AlleyPond</h1>

      </div>
      <div class="login-card">
        <div class="card-title">Login Form</div>
        <a-form-model id="formLogin" ref="form" class="user-layout-login" :model="form" :rules="rules">
          <a-alert
            v-if="isLoginError"
            type="error"
            showIcon
            style="margin-bottom: 24px;"
            :message="loginErrorInfo"
            closable
            :after-close="handleCloseLoginError"
          />
          <a-form-model-item prop="accountNo">
            <a-input v-model="form.accountNo" size="large" placeholder="账户">
              <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
          </a-form-model-item>
          <a-form-model-item prop="password">
            <a-input-password v-model="form.password" size="large" placeholder="密码">
              <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input-password>
          </a-form-model-item>
          <a-row v-if="captchaEnabled" :gutter="16">
            <a-col class="gutter-row" :span="16">
              <a-form-model-item prop="code">
                <a-input
                  v-model="form.validCode"
                  size="large"
                  type="text"
                  autocomplete="off"
                  :placeholder="$t('app.setting.yanzhengma.yanzhengma')"
                >
                  <a-icon slot="prefix" type="security-scan" :style="{ color: 'rgba(0,0,0,.25)' }" />
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col class="gutter-row" :span="8">
              <img class="getCaptcha" :src="codeUrl" @click="getCode">
            </a-col>
          </a-row>
          <a-form-model-item prop="rememberMe">
            <a-checkbox :checked="form.rememberMe" @change="rememberMe">{{ $t('app.setting.jizhumima.jizhumima') }}</a-checkbox>
          </a-form-model-item>
          <a-form-item style="margin-top:24px">
            <a-button
              size="large"
              type="primary"
              htmlType="submit"
              class="login-button"
              :loading="logining"
              :disabled="logining"
              @click="handleSubmit"
            >
              {{ $t('app.setting.login.confirm') }}
            </a-button>
          </a-form-item>

          <div class="user-login-other" />
        </a-form-model>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import { getCodeImg } from '@/api/login'
import { LOGIN_USERNAME, LOGIN_PASSWORD, LOGIN_REMEMBERME } from '@/store/mutation-types'
import storage from 'store'
import selectLang from "@/components/SelectLang"
export default {
  components: {
    selectLang
  },
  data() {
    return {
      codeUrl: '',
      isLoginError: false,
      loginErrorInfo: '',
      form: {
        accountNo: '',
        password: '',
        validCode: undefined,
        validCodeReqNo: '',
        rememberMe: false
      },
      rules: {
        accountNo: [{ required: true, message: '请输入帐户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        validCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      logining: false,
      captchaEnabled: true,
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    this.getStorage()
    if (this.captchaEnabled) {
      this.getCode()
    }
  },
  methods: {
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.data.captchaEnabled === undefined ? true : res.data.captchaEnabled
        if (this.captchaEnabled) {
          this.codeUrl = 'data:image/gif;base64,' + res.data.img
          this.form.validCodeReqNo = res.data.uuid
        }
      })
    },
    getStorage() {
      const accountNo = storage.get(LOGIN_USERNAME)
      const password = storage.get(LOGIN_PASSWORD)
      const rememberMe = storage.get(LOGIN_REMEMBERME)
      if (accountNo) {
        this.form = {
          accountNo: accountNo,
          password: password,
          rememberMe: rememberMe
        }
      }
    },
    rememberMe(e) {
      this.form.rememberMe = e.target.checked
    },
    ...mapActions(['Login', 'Logout']),

    //新增
     _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
          },
    handleSubmit() {
      // console.log(this.form);
      // return;
      this.logining = true
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.rememberMe) {
            storage.set(LOGIN_USERNAME, this.form.accountNo)
            storage.set(LOGIN_PASSWORD, this.form.password)
            storage.set(LOGIN_REMEMBERME, this.form.rememberMe)
          } else {
            storage.remove(LOGIN_USERNAME)
            storage.remove(LOGIN_PASSWORD)
            storage.remove(LOGIN_REMEMBERME)
          }
          this.$store.dispatch('Login', this.form).then((res) => {
            console.log('999', res)
            this.$router.push({ path: this.redirect || '/' }).catch(() => { })
          }).catch((err) => {
            console.log('err', err)
            this.loading = false
            setTimeout(() => {
              this.logining = false
            }, 1000)
            if (this.captchaEnabled) {
              this.getCode()
            }
          })
          // this.Login(this.form)
          //   .then((res) => this.loginSuccess(res))
          //   .catch(err => this.requestFailed(err))
          //   .finally(() => {
          //     this.logining = false
          //   })
        } else {
          setTimeout(() => {
            this.logining = false
          }, 600)
        }
      })
    },
    loginSuccess(res) {
      this.$router.push({ path: '/' })
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
      this.handleCloseLoginError()
    },
    requestFailed(err) {
      this.isLoginError = true
      this.loginErrorInfo = err
      this.form.code = undefined
      if (this.captchaEnabled) {
        this.getCode()
      }
    },
    handleCloseLoginError() {
      this.isLoginError = false
      this.loginErrorInfo = ''
    }
  }
}
</script>

<style lang="less" scoped>
.login-page {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  overflow: hidden;
  background: linear-gradient(130deg, #f6d9f6 0%, #efbde2 34%, #d8cdfa 65%, #89dff8 100%);
}

.login-shell {
  position: relative;
  z-index: 3;
  width: 100%;
  max-width: 430px;
  margin: 0 auto;
}

.login-header {
  position: static;
  width: auto;
  text-align: center;
  margin-bottom: 18px;

  h1 {
    margin: 0;
    font-size: 34px;
    line-height: 1.2;
    color: rgba(255, 255, 255, 0.95);
    letter-spacing: 3px;
    font-weight: 700;
    text-shadow: 0 4px 14px rgba(137, 85, 150, 0.34);
  }

  p {
    margin: 10px 0 0;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.86);
  }
}

.login-card {
  position: static;
  width: 420px;
  max-width: 100%;
  border-radius: 18px;
  padding: 28px 26px 22px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.42);
  box-shadow: 0 18px 36px rgba(109, 73, 124, 0.24);
  backdrop-filter: blur(12px);
}

.card-title {
  margin-bottom: 18px;
  font-size: 30px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
  letter-spacing: 1px;
}

.user-layout-login {
  label {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.9);
  }

  /deep/ .ant-form-item {
    margin-bottom: 16px;
  }

  /deep/ .ant-input,
  /deep/ .ant-input-password,
  /deep/ .ant-input-affix-wrapper {
    border-radius: 22px;
    border: 1px solid rgba(255, 255, 255, 0.38);
    background: rgba(255, 255, 255, 0.3);
    color: #1f1f1f;
  }

  /deep/ .ant-input::placeholder,
  /deep/ .ant-input-password input::placeholder {
    color: rgba(0, 0, 0, 0.42);
  }

  /deep/ .ant-input,
  /deep/ .ant-input-password input {
    color: #1f1f1f;
  }

  /deep/ .ant-checkbox-wrapper {
    color: rgba(255, 255, 255, 0.9);
  }

  /deep/ .anticon {
    color: rgba(0, 0, 0, 0.45) !important;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
    border-radius: 20px;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0.4);
    object-fit: cover;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 44px;
    width: 100%;
    border: none;
    border-radius: 22px;
    background: linear-gradient(135deg, #fffefb 0%, #f7f6ff 100%);
    box-shadow: 0 10px 24px rgba(131, 89, 152, 0.28);
    color: #9d5db7;
    font-weight: 700;
  }

  .user-login-other {
    text-align: left;
    margin-top: 8px;
    line-height: 22px;
  }
}

.bg-circle {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  animation: floatBubble 4.6s ease-in-out infinite;
}

.bg-circle-a {
  width: 420px;
  height: 420px;
  right: 10%;
  top: 18%;
  background: rgba(255, 255, 255, 0.16);
  animation-duration: 5s;
}

.bg-circle-b {
  width: 340px;
  height: 340px;
  left: -80px;
  bottom: -120px;
  background: rgba(255, 240, 204, 0.24);
  animation-duration: 5.6s;
  animation-delay: -2s;
}

.bg-circle-c {
  width: 260px;
  height: 260px;
  right: -60px;
  bottom: -80px;
  background: rgba(84, 232, 255, 0.24);
  animation-duration: 4.8s;
  animation-delay: -1s;
}

.glass-cube {
  position: absolute;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.35);
  box-shadow: 0 10px 22px rgba(112, 87, 130, 0.16);
  backdrop-filter: blur(6px);
  pointer-events: none;
  animation: floatCube 3.4s ease-in-out infinite;
}

.cube-a {
  width: 84px;
  height: 84px;
  left: 24%;
  top: 22%;
  animation-delay: -1.5s;
}

.cube-b {
  width: 58px;
  height: 58px;
  right: 26%;
  top: 18%;
  animation-duration: 4.1s;
  animation-delay: -0.8s;
}

.cube-c {
  width: 66px;
  height: 66px;
  right: 28%;
  bottom: 16%;
  animation-duration: 4.4s;
  animation-delay: -2.5s;
}

@keyframes floatBubble {
  0% {
    transform: translate3d(0, 0, 0) scale(1);
  }
  50% {
    transform: translate3d(0, -36px, 0) scale(1.08);
  }
  100% {
    transform: translate3d(0, 0, 0) scale(1);
  }
}

@keyframes floatCube {
  0% {
    transform: translate3d(0, 0, 0) rotate(0deg);
  }
  50% {
    transform: translate3d(0, -28px, 0) rotate(12deg);
  }
  100% {
    transform: translate3d(0, 0, 0) rotate(0deg);
  }
}
</style>
